import {Injectable} from '@angular/core';
import {ApiService} from '@common-lib';

@Injectable()
export class MediaService {

    constructor(
        private api: ApiService,
    ) {
    }

    uploadFile(fileToUpload: File, path) {
        const apiPath = '/filemanager/files';
        const formData: FormData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        return this.api.uploadFile(formData, path, fileToUpload.name, apiPath);
    }

    getList() {
        return this.api.get('/filemanager/files');
    }

    updateMediaInfo(media) {
        return this.api.post('/filemanager/files-titles ', media);
    }

    deleteFile(filename) { // for delete images in products and image sections
        return this.api.delete(`/filemanager/files`, {headers: {filename}});
    }

    deleteVideo(id) { // for delete video
        return this.api.delete(`/filemanager/files-media`, {headers: {id}});
    }

}



// WEBPACK FOOTER //
// ./src/app/pages-services/media.service.ts